/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menufilesecondpdf3Inputs */

const en_menufilesecondpdf3 = /** @type {(inputs: Menufilesecondpdf3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only one PDF per reading.`)
};

const de_menufilesecondpdf3 = /** @type {(inputs: Menufilesecondpdf3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur ein PDF pro Einlesen.`)
};

/**
* | output |
* | --- |
* | "Only one PDF per reading." |
*
* @param {Menufilesecondpdf3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menufilesecondpdf3 = /** @type {((inputs?: Menufilesecondpdf3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menufilesecondpdf3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menufilesecondpdf3(inputs)
	return de_menufilesecondpdf3(inputs)
});
export { menufilesecondpdf3 as "menuFileSecondPdf" }